window.$ = window.jQuery = require('jquery');
window.routie = require('./auth/routie.min.js');
require('./frontend/bootstrap.min.js');
window.Sticky = require('./frontend/jquery.sticky.js');
require('./frontend/main-frontend.js');
window.toastr = require('./frontend/toastr.js');
require('./auth/auth.js');


require("slick-carousel/slick/slick.min");

import '@popperjs/core';

